import * as React from 'react';

import {EmptyAddCard} from 'shells/card/empty-add-card';

import type {FieldCreateInput} from 'nutshell-graphql-types';

import type {
    FormFieldRowForDuplicateHelpers,
    HeaderFieldType,
    ImageFieldType,
} from '../../../../types';

import {AddBlockCard} from './add-block-card';

import styles from './add-card.module.css';

type Props = {
    formId: string;
    fields: FormFieldRowForDuplicateHelpers[];
    formSchema: any;
    fetchFormSchema: () => void;
    onAddCardClick: () => void;
    onCreateNewField: (arg1: FieldCreateInput) => any;
};

export function AddBlock(props: Props) {
    const [isAddingBlock, setIsAddingBlock] = React.useState<boolean>(false);

    const addBlockRef = React.useRef(null);

    React.useEffect(() => {
        if (addBlockRef && addBlockRef.current) {
            // @ts-expect-error
            addBlockRef.current.scrollIntoView();
        }
    }, [isAddingBlock]);

    const onClose = () => setIsAddingBlock(false);

    return (
        <div>
            {isAddingBlock ? (
                <div
                    ref={(ref) => {
                        // @ts-expect-error
                        addBlockRef.current = ref;
                    }}
                    className={styles['add-card-container']}
                >
                    <AddBlockCard
                        formId={props.formId}
                        fields={props.fields}
                        onSelectInputField={(input) => {
                            props.onCreateNewField(input);
                            setTimeout(() => {
                                onClose();
                            }, 500);
                        }}
                        onSelectHeaderField={(type: HeaderFieldType | ImageFieldType) => {
                            props.onCreateNewField({
                                type,
                                formId: props.formId,
                            });
                            onClose();
                        }}
                        onClose={onClose}
                        formSchema={props.formSchema}
                        fetchFormSchema={props.fetchFormSchema}
                    />
                </div>
            ) : (
                <div className={styles['new-item-container']}>
                    <EmptyAddCard
                        text='Add a block'
                        onClick={() => {
                            props.onAddCardClick();
                            setIsAddingBlock(true);
                        }}
                        background='off-white'
                        size='small'
                        withoutIcon={true}
                    />
                </div>
            )}
        </div>
    );
}
